/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface PendingNotificationResponse {
  /** Pending notification ID */
  pending_notification_id: string;
  /** Scheduled send time */
  date: string;
  /** Notification content body */
  content: string;
  /** Status: queued, processing, sent, failed, cancelled, or skipped */
  status: string;
}
